<template>
  <div>
    <ModalBoleto v-model="abreModal" :titulo="'Boleto Projeto - ' + sqProjetoVar" :src="urlPagamento" />
    <ModalQrCode v-model="mostraQRCode" :qrCodeImage="qrCodeImage" :textAreaData="textAreaData" :valor="vlAstec" :titulo="'QR Code Pix Projeto - ' + sqProjetoVar" />

    <PageHeader :title="titleHeader" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row d-flex justify-content-between">
          <div class="col-md-8">
            <b-card-title>
              <h5 class="card-title mb-3">Informações do Projeto -
                <span v-if="!importacao"
                  class="badge badge-pill font-size-15"             
                  :class="{
                            'badge-soft-info': statusProjeto === 'ELABORADO',
                            'badge-soft-success': statusProjeto === 'LIBERADO',
                            'badge-soft-dark': statusProjeto === 'LIQUIDADO',
                            'badge-soft-danger': statusProjeto === 'EXCLUIDO',
                            'badge-soft-warning': statusProjeto === 'BAIXA PARCIAL',
                          }">
                  {{statusProjeto}}
                </span>

                <span v-else
                  class="badge badge-pill font-size-12"
                  :class="{
                            'badge-soft-info': statusProjeto === 'COMPLETO',
                            'badge-soft-success': statusProjeto === 'EXPORTADO',
                            'badge-soft-danger': statusProjeto === 'INCOMPLETO',
                          }"
                >
                  {{ statusProjeto }}
                </span>
                <span v-if="sqProjetoVar"> - {{sqProjetoVar}}</span>
              </h5>
            </b-card-title>
          </div>
            <div class="col-md-4 d-flex justify-content-end mb-3" v-if="permiteDuplicar && !importacao">
            <b-button variant="primary" @click="duplicarProjeto()">
              <i class='bx bx-copy'></i> 
              Duplicar Informações
            </b-button>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group label="Cooperado" :state="state('selecaoCooperado')">
              <multiselect
                v-model="selecaoCooperado"
                :options="cooperadoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                :allowEmpty="false"
                :taggable="false"
                select-label=""
                @input="carregarClienteRural"
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao"
              >
                <span slot="noOptions">Nenhum Cooperado disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Cliente Rural" :state="state('selecaoClienteRural')">
              <multiselect
                v-model="selecaoClienteRural"
                :options="clienteRuralLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao"
                :loading="loadingClienteRural"
              >
                <span slot="noOptions">Nenhum Cliente Rural disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="CPF/CNPJ" :state="state('selecaoClienteRural')">
              <multiselect
                label="cpfCnpj"
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao"
                v-model="selecaoClienteRural"
                :options="filteredOptions" 
                :custom-label="formatCpfCnpj"
                track-by="cpfCnpj"
                placeholder="Selecione"
                select-label=""
                :loading="loadingClienteRural"
                :max-height="200"
                :internal-search="false"
                @search-change="updateSearch"
              >
                <span slot="noOptions">Nenhum CPF/CNPJ disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="N° Projeto" invalid-feedback="Campo obrigatório" >
              <b-form-input v-model="numeroProjeto" v-mask="'########'" type="text" :maxlength="8" :state="state('numeroProjeto')" :disabled="disabledCampos || importacao"/>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Data do Projeto" :state="state('dataProjeto')" invalid-feedback="Campo obrigatório">
              <date-picker
                v-model="dataProjeto"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="disabledCampos || importacao"
                :disabled-date="disableDatasFuturas"
                @input="disableDatasPosteriores()"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group label="Instituição Financeira" :state="state('selecaoInstituicaoFinanceira')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoInstituicaoFinanceira" :loading="loadingInstFinanceira" :disabled="disabledCampos || importacao" :options="instituicaoFinanceiraLkp" label="name" track-by="name" placeholder="Selecione" select-label="" @input="carregarAgencia"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Agência" :state="state('selecaoAgencia')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoAgencia" :loading="loadingAgencia" :disabled="disabledCampos" :options="instituicaoAgenciaLkp" label="name" track-by="name" placeholder="Selecione" select-label=""  />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Município - UF" :state="state('selecaoMunicipio')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoMunicipio" :disabled="disabledCampos" :options="selecaoMunicipioLkp" label="name" track-by="name" placeholder="Selecione" select-label=""/>
            </b-form-group>
          </div>

          <div class="col-md-3">          
            <b-form-group label="Linha de Crédito" :state="state('selecaoLinhaCredito')" invalid-feedback="Campo obrigatório">
              <multiselect
                v-model="selecaoLinhaCredito"
                :options="linhaCreditoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                :disabled="disabledCampos || importacao"
              >
                <span slot="noOptions">Nenhuma Linha de Crédito disponível</span>
              </multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group label="Safra" :state="state('selecaoSafra')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoSafra" :disabled="disabledCampos || importacao" :options="selecaoSafraLkp" label="name" track-by="name" placeholder="Selecione" select-label="" @input="carregarItemAgropecuario"/>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="Tipo de Projeto" :state="state('selecaoTipoProjeto')" invalid-feedback="Campo obrigatório">
              <multiselect
                v-model="selecaoTipoProjeto"
                :options="tipoProjetoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarItemAgropecuario"
                :disabled="disabledCampos"
              >
                <span slot="noOptions">Nenhum Tipo de Projeto disponível</span>
              </multiselect>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="Item Agropecuário" :state="state('selecaoItemAgropecuario')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoItemAgropecuario" :disabled="disabledCampos" :options="itemAgropecuarioLkp" :loading="loadingItemAgropecuario" label="name" track-by="name" placeholder="Selecione" select-label="">
                <span slot="noOptions">Lista vazia, selecione a safra e tipo de projeto.</span>
              </multiselect>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="Área (ha)" invalid-feedback="Campo obrigatório" :state="state('areaHa')" >
              <money
                v-model="areaHa"
                v-bind="area"
                class="form-control"
                :state="state('areaHa')" 
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>

        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group label="Modalidade do Seguro" :state="state('selecaoModalidadeSeguro')" invalid-feedback="Campo obrigatório">
              <multiselect v-model="selecaoModalidadeSeguro" :disabled="disabledCampos || importacao" :options="selecaoModalidadeSeguroLkp" label="name" track-by="name" placeholder="Selecione" select-label=""/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Orçado" :state="state('vlOrcado')" invalid-feedback="Campo obrigatório">
              <money
                v-model="vlOrcado"
                v-bind="money"
                class="form-control"
                :state="state('vlOrcado')" 
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="% Astec" invalid-feedback="Campo obrigatório">
              <input v-model.lazy="perAstec" v-money="porcentagem" class="form-control" :maxlength="8"  :state="state('perAstec')" :disabled="disabledCampos || importacao"/>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Valor Astec" :state="state('vlAstec')" invalid-feedback="Campo obrigatório" >
              <money
                v-model="vlAstec"
                v-bind="money"
                class="form-control money-mask"
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>
        </div>
        
        <div v-if="!importacao" class="row d-flex mb-3">
          
          <div class="col-md-3">
            <b-form-group label="Projeto Unicampo">
              <multiselect v-model="selecaoProjeto" :options="selecaoProjetoLkp" label="name" track-by="name" placeholder="Selecione" select-label="" :disabled="true" :max-height="150"/>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group label="N° Operação" invalid-feedback="Campo obrigatório">
              <b-form-input v-model="nOperacao" v-mask="'##################'" :maxlength="30" type="text" :disabled="disabledCampos"/>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group label="Data Vencimento" invalid-feedback="Campo obrigatório">
              <date-picker
                v-model="dataVencBoleto"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="disabledCampos"
                :disabled-date="disableDatasAnteriores"
              />
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group label="Valor Liberado" invalid-feedback="Campo obrigatório">
              <money
                v-model="vlLiberado"
                v-bind="money"
                class="form-control"
                :disabled="true"
              >
              </money>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group label="Data Crédito" invalid-feedback="Campo obrigatório">
              <date-picker
                v-model="dataCredito"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="true"
              />
            </b-form-group>
          </div>

        </div>

        <div class="row d-flex justify-content-between mb-1 align-items-center">
          <div class="col-md-6 d-flex justify-content-start align-items-center">
            <div v-if="!importacao">
              <b-button :disabled="!sqProjetoVar > 0 || loadingSalvar || !permiteDuplicar || disabledCampos" variant="light" size="lg" class="me-md-1 mb-2 mb-md-0" data-tooltip="Gerar Boleto" data-tooltip-location="bottom" @click="gerarBoleto">
                <i class="mdi mdi-barcode"></i>
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
              </b-button>
              <b-button :disabled="!sqProjetoVar > 0 || loadingSalvar || !permiteDuplicar || disabledCampos" variant="light" size="lg" class="me-md-1 mb-2 mb-md-0" data-tooltip="Gerar Pix" data-tooltip-location="bottom" @click="gerarPix"> 
                <img :src="require('@/assets/images/pix-brands-solid.svg')" alt="Pix Brands" height="18">
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
              </b-button>
              <b-button :disabled="!sqProjetoVar > 0 || loadingSalvar" variant="light" size="lg" data-tooltip="Movimentações" data-tooltip-location="bottom"> 
                <i class="fa fa-solid fa-wallet"></i>
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
              </b-button>
            </div>
          </div>

          <div class="col-md-6  d-flex justify-content-end align-items-center">
            <b-button variant="secondary" size="md" class="me-md-1 mb-2 mb-md-0" @click="voltar" data-tooltip="Voltar" data-tooltip-location="bottom">
              <i class="mdi mdi-arrow-left-circle"></i>
              Voltar
            </b-button>

            <b-button 
              variant="success" 
              size="md"  
              @click="insertProjeto('voltar')" 
              :disabled="loadingSalvar || disabledCampos" 
              data-tooltip="Salvar e Voltar"
              data-tooltip-location="bottom"
              class="me-md-1 mb-2 mb-md-0"
            >
              <i class="mdi mdi-content-save"></i> 
              Salvar e Voltar
              <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
            </b-button>

            <b-button v-if="!importacao && !editandoProjeto"
              variant="success" 
              size="md"  
              @click="insertProjeto('continuar')" 
              :disabled="loadingSalvar || disabledCampos || editandoProjeto" 
              data-tooltip="Salvar e Continuar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-content-save"></i> 
              Salvar e Continuar
              <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
            </b-button>

            <b-button v-else-if="!importacao && editandoProjeto"
              variant="success" 
              size="md"  
              @click="insertProjeto('salvar')" 
              :disabled="loadingSalvar || disabledCampos" 
              data-tooltip="Salvar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-content-save"></i> 
              Salvar
              <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
            </b-button>

            <b-button v-else
              variant="success" 
              size="md"  
              @click="insertProjeto('exportar')" 
              :disabled="loadingSalvar || disabledCampos" 
              data-tooltip="Salvar e Exportar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-content-save"></i> 
              Salvar e Exportar
              <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
            </b-button>

          </div>
        </div>
      </div>
    </div>

    <formDadosImportados v-if="importacao && !loading"/>
  </div>
</template>

<script>
import Multiselect            from "vue-multiselect";
import PageHeader             from "@/components/page-header";
import clienteRuralMixin      from "@/tools/mixins/clienteRuralMixin.js";
import formDadosImportados    from "@/components/astec/projetos/lotesImportacao/formDadosImportados";
import Swal                   from "sweetalert2";
import ModalBoleto            from "@/components/assinaturaEletronica/modalAssinatura";
import ModalQrCode            from "@/components/astec/modalQrCode";
import { Money }              from "v-money";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  mixins    : [clienteRuralMixin],
  components: { Multiselect, PageHeader, Money, formDadosImportados, ModalBoleto, ModalQrCode},
  data() {
    return {
      statusProjeto               : '',
      selecaoCooperado            : null,
      cooperadoLkp                : [],
      clienteRuralLkp             : [],
      selecaoClienteRural         : null,
      selecaocpfCnpj              : '', 
      cpfCnpjInvalido             : false, 
      numeroProjeto               : "",
      dataProjeto                 : null, 
      linhaCreditoLkp             : [], 
      selecaoLinhaCredito         : null, 
      selecaoTipoProjeto          : null,
      tipoProjetoLkp              : [],
      selecaoModalidadeSeguro     : null,
      selecaoModalidadeSeguroLkp  : [],
      StatusLkp                   : [],
      selecaoStatus               : null,
      itemAgropecuarioLkp         : [],
      selecaoItemAgropecuario     : null,
      selecaoMunicipio            : null,
      selecaoMunicipioLkp         : [],
      selecaoSafra                : null,
      selecaoSafraLkp             : [],
      selecaoProjeto              : null,
      selecaoProjetoLkp           : [],
      areaHa                      : "",
      nOperacao                   : "",
      vlOrcado                    : "",
      perAstec                    : "",
      vlAstec                     : "",
      vlLiberado                  : "",
      dataCredito                 : null,
      instituicaoFinanceiraLkp    : [],
      selecaoInstituicaoFinanceira: null,
      loadingInstFinanceira       : false,
      loadingClienteRural         : false,
      loadingAgencia              : false,
      loadingItemAgropecuario     : false,
      instituicaoAgenciaLkp       : [],
      selecaoAgencia              : null,
      dataVencBoleto              : null,
      cdPessoa                    : "",
      sqUsuario                   : "",
      cdProjeto                   : 30,
      sqProjetoVar                : null,
      loading                     : true,
      loadingSalvar               : false,
      submit                      : false,
      disabledCampos              : false,
      titleHeader                 : "",
      money: {
        decimal  : ",",
        thousands: ".",
        precision: 2,
        prefix   : "R$ ",
        masked   : false,
      },
      area: {
        decimal  : ",",
        thousands: ".",
        suffix   : ' (ha)',
        precision: 2,
        masked   : false,
      },
      porcentagem: {
        decimal  : ",",
        thousands: ".",
        suffix   : ' %',
        precision: 2,
        masked   : false,
      },
      searchQuery    : "",
      dadosAoCarregar: null,
      editandoProjeto: false,
      importacao     : false,
      permiteDuplicar: false,
      abreModal      : false,
      urlPagamento   : "",
      mostraQRCode   : false,
      qrCodeImage    : '',
      textAreaData   : '',
    };
  },
  async created() {
    this.importacao = localStorage.getItem('exibirCamposImportacao') === 'true';

    await this.buscarDados();

    if(this.$store.state.projetoAstec){
      var projeto = this.$store.state.projetoAstec;

      this.titleHeader     = "Editando Projeto Astec";
      this.cdProjeto       = projeto.CD_PROJETO;
      this.sqProjetoVar    = projeto.SQ_PROJETO_VAR;
      this.editandoProjeto = true;
      
      if(this.importacao){
        this.statusProjeto = projeto.ST_IMPORTACAO;
      }else{
        this.statusProjeto = projeto.ST_PROJETO;
      }

      if(projeto.ST_PROJETO !== "ELABORADO" && projeto.ST_IMPORTACAO !== "INCOMPLETO" && projeto.ST_IMPORTACAO !== "COMPLETO"){
        this.titleHeader    = "Consultando Projeto Astec";
        this.disabledCampos = true;
      }

      if(this.cdProjeto == 30 && projeto.CD_PESSOA_CORRETORA == 0 || projeto.CD_PESSOA_CORRETORA == null){
        this.permiteDuplicar = true;
      } else {
        this.permiteDuplicar = false;
      }

      await this.preencherCampos(projeto);
    } else {
      this.titleHeader   = "Criando Projeto Astec";
      this.statusProjeto = "ELABORADO"
    }

    this.selecaoProjeto = this.selecaoProjetoLkp.find(
      (el) => el.value == this.cdProjeto
    );

    this.$tools.fecharMenu();

    this.dadosAoCarregar = this.montarObjeto();
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery) return this.clienteRuralLkp;
      // Remove formatação do input do usuário
      const normalizedSearch = this.normalizeCpfCnpj(this.searchQuery);

      return this.clienteRuralLkp.filter(option => {
        // Remove formatação do CPF/CNPJ da opção
        const normalizedOption = this.normalizeCpfCnpj(option.cpfCnpj);
        return normalizedOption.includes(normalizedSearch);
      });
    }
  },
  validations: {
    selecaoCooperado            : { required, },
    selecaoClienteRural         : { required, },
    numeroProjeto               : { required},
    dataProjeto                 : { required, },
    selecaoLinhaCredito         : { required ,},
    selecaoTipoProjeto          : { required, },
    selecaoItemAgropecuario     : { required, },
    selecaoModalidadeSeguro     : { required, },
    selecaoMunicipio            : { required, },
    selecaoSafra                : { required, },
    areaHa                      : { required, minValue: minValue(0.01) },
    vlOrcado                    : { required, minValue: minValue(1) },
    perAstec                    : { required, },
    vlAstec                     : { required, },
    selecaoInstituicaoFinanceira: { required, },
    selecaoAgencia              : { required, },
  },
  watch: {
    vlOrcado() {
      this.calcularVlAstec();
    }, 
    perAstec() {
      this.calcularVlAstec();
    },
  },
  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarMunicipioUf();
      await this.buscarLkpSafra();
      await this.buscarLkpProjeto();
      await this.carregarClienteRural();

      this.loading = false;
    },

    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },
    
    disableDatasFuturas(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    disableDatasPosteriores(date) {
      if(this.dataProjeto){
        const today = new Date(this.dataProjeto);
        today.setHours(0, 0, 0, 0);
        return date < today;
      }

      return date;
    },

    disableDatasAnteriores(date) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return date < hoje;
    },

    async preencherCampos(projeto) {
      if (projeto) {
        this.selecaoCooperado = this.cooperadoLkp.find(
          (el) => el.value == projeto.CD_COOPERADO
        );

        await this.carregarClienteRural()
        
        this.selecaoClienteRural = this.clienteRuralLkp.find(
          (el) => el.value == projeto.SQ_CLIENTE
        );
        
        this.numeroProjeto = projeto.NR_PROJETO;
        this.dataProjeto   = projeto.DT_PROJETO;
        
        this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
          (el) => el.value == projeto.CD_LINHA_CREDITO
        );
        
        this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
          (el) => el.name.split(" [")[0] === projeto.DS_TP_PROJETO,
        );
        
        this.selecaoSafra = this.selecaoSafraLkp.find(
          (el) => el.name == projeto.CD_SAFRA
        );
        
        await this.carregarItemAgropecuario()
        
        this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
          (el) => el.name.split(" [")[0] == projeto.DS_ITEM_AGROPECUARIO
        );
        
        this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
          (el) => el.value == projeto.CD_MODALIDADE_SEGURO
        );
        
        this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
          (el) => el.value == projeto.SQ_REGIAO_PROJETO
        );
        
        this.areaHa      = parseFloat(projeto.QT_AREA);
        this.nOperacao   = projeto.CD_OPERACAO_CRED;
        this.vlOrcado    = parseFloat(projeto.VL_ORCADO);
        this.vlAstec     = parseFloat(projeto.VL_ASTEC);
        this.vlLiberado  = parseFloat(projeto.VL_LIBERADO);
        this.dataCredito = projeto.DT_CREDITO_BCO;
        
        this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
          (el) => el.value == projeto.CD_INSTITUICAO_FINANCEIRA
        );

        await this.carregarAgencia();
        
        this.selecaoAgencia = this.instituicaoAgenciaLkp.find(
          (el) => el.value == projeto.NR_AGENCIA
        );
        
        const valor = parseFloat(projeto.PER_ASTEC.replace(',', '.'));
        
        if (!isNaN(valor)) {
          this.perAstec = valor.toFixed(2).replace('.', ',');
        } else {
          this.perAstec = projeto.PER_ASTEC;
        }

        this.dataVencBoleto = projeto.DT_VENC_BOLETO;
      } else {
        this.$tools.alerta("Ocorreu um erro ao preencher os campos, por favor tente novamente.", "error");
      }
    },

    calcularVlAstec() {
      if (parseFloat(this.perAstec.replace(",", ".")) > 100.00) {
        this.perAstec = "100";
      }

      if (this.vlOrcado && this.perAstec) {
        const percentualStr = this.perAstec.replace(",", ".");
        const percentual    = parseFloat(percentualStr) / 100.00;
        
        this.vlAstec        = percentual * this.vlOrcado;
      }
    },

    async getNomeRazaoUsuario() {
      try {
        this.cdPessoa  = this.$store.state.me?.cd_pessoa;
        this.sqUsuario = this.$store.state.me?.sq_usuario;
      } catch {
        this.logoutUser();
      }
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length > 0) {
        const cooperadoEncontrado = this.cooperadoLkp.find(cooperado => cooperado.value === this.cdPessoa);
        
        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
          this.carregarInstFinanceira();
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }
      
      return;
    },

    async carregarClienteRural(){
      if(this.selecaoCooperado){
        this.clienteRuralLkp     = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;

        try {
          const response = await this.$http.get("/api/astec/getLkpClienteRuralProjetos/" + this.selecaoCooperado.value);
          
          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name   : cliente.DISPLAY,
              value  : cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ,
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingClienteRural = false;
        await this.carregarInstFinanceira();
      }
    },

    async carregarInstFinanceira(){
      this.instituicaoFinanceiraLkp     = [];
      this.instituicaoAgenciaLkp        = [];
      this.selecaoInstituicaoFinanceira = null;
      this.selecaoAgencia               = null;
      this.loadingInstFinanceira        = true;
      
      await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);
      
      this.loadingInstFinanceira        = false;
    },

    async carregarAgencia(){
      if(this.selecaoInstituicaoFinanceira){
        this.selecaoAgencia = null;
        this.loadingAgencia = true;
        
        try {
          const response = await this.$http.get("/api/astec/getLkpAgencia/"  + this.cdPessoa + "/" + this.selecaoInstituicaoFinanceira.value);
          
          this.instituicaoAgenciaLkp = response.data.map(nrAgencia => ({
            name : nrAgencia.DISPLAY,
            value: nrAgencia.ID, 
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        
        this.loadingAgencia = false;
      } else {
        this.instituicaoAgenciaLkp = [];
        this.selecaoAgencia        = null;
      }

      return;
    },

    async carregarItemAgropecuario(){
      if(this.selecaoTipoProjeto){
        this.perAstec = this.selecaoTipoProjeto.perAstec;
      }
      
      if(this.selecaoTipoProjeto && this.selecaoSafra){
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;
      
        try {
          const response = await this.$http.get("/api/astec/getLkpItemAgropecuario/" + this.selecaoTipoProjeto.value + "/" + this.selecaoSafra.epoca);
      
          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name : itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID,
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingItemAgropecuario = false;
      } else {
        if(!this.selecaoTipoProjeto){
          this.perAstec = '';
        }

        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp     = [];
      }

      return;
    },

    duplicarProjeto(){
      this.loading          = true;
      this.sqProjetoVar     = null;
      this.cdProjeto        = 30;
      this.statusProjeto    = "ELABORADO";
      this.numeroProjeto    = "";
      this.dataProjeto      = "";
      this.selecaoSafra     = "";
      this.nrOperacao       = "";
      this.vlOrcado         = "";
      this.vlAstec          = "";
      this.vlLiberado       = "";
      this.dataCredito      = "";
      this.nOperacao        = "";
      this.dataVencBoleto   = "";
      this.perAstec         = "",
      this.titleHeader      = "Duplicando Projeto Astec"
      this.permiteDuplicar  = false;

      setTimeout(() => {
        this.loading        = false;
        this.disabledCampos = false;
      }, 1000);
    },

    /* 
      acao: "voltar"    - Salva e volta para a lista de projetos
      acao: "continuar" - Salva e permanece na tela de criação do projeto
      acao: "salvar"    - Salva o projeto que está sendo editado e permanece na tela, para caso o usuário queira gerar o boleto ou pix
    */
    insertProjeto(acao) {
      this.loadingSalvar = true;
      this.submit        = true;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.loadingSalvar = false;
        return;
      }

      const obj = this.montarObjeto();

      if(this.importacao){
        
        const sqAstecIntegracaoItem = this.$store.state.projetoAstec.SQ_ASTEC_INTEGRACAO_ITEM;
        const sqAstecIntegracaoLote = this.$store.state.projetoAstec.SQ_ASTEC_INTEGRACAO_LOTE;

        const objImportacao = {
          ...obj,
          acao: acao
        }

        this.$http.put(`/api/astec/projetos/importarProjetos/projetosLote/${sqAstecIntegracaoItem}/${sqAstecIntegracaoLote}`, objImportacao)
        .then((response) => {
          Swal.fire({
            icon : "success",
            title: "Sucesso",
            text : response.data.message,
          });

          localStorage.removeItem('exibirCamposImportacao');

          this.$router.push("/astec/projetos/lotesImportacao/projetosLote");
        })
        .catch((error) => {
          if(error.response.data.message != ""){
            this.$tools.alerta(error.response.data.message, "error");
          } else {
            this.$tools.alerta("Erro ao salvar projeto", "error");
          }
        })
        .finally(() => {
          this.loadingSalvar = false;
        });

      }else{

        this.$http.post("/api/astec/insertProjetos", obj)
        .then(response => {
          Swal.fire({
            icon : "success",
            title: "Sucesso",
            text : "Projeto " + response.data[0].ID + " salvo com sucesso!",
          });
  
          if(acao === "voltar"){
            this.$router.push("/astec/projetos");
          }else if(acao === "continuar"){
            this.limparFormCadastro();
          }
        })
        .catch(err => {
          if(err.response.data.message != ""){
            this.$tools.alerta(err.response.data.message, "error");
          } else {
            this.$tools.alerta("Erro ao salvar projeto", "error");
          }
        })
        .finally(() => {
          this.loadingSalvar = false;
        });
      }
      
    },

    montarObjeto() {
      const dados = {
        sqUsuario              : this.sqUsuario,
        sqProjetoVar           : this.sqProjetoVar,
        cdProjeto              : this.cdProjeto,
        cdCooperado            : this.selecaoCooperado             ? this.selecaoCooperado.value                  : null,
        sqCliente              : this.selecaoClienteRural          ? this.selecaoClienteRural.value               : null,
        nrPlano                : this.numeroProjeto                ? this.numeroProjeto                           : null,
        dtProjeto              : this.dataProjeto                  ? this.dataProjeto                             : null,
        sqLinhaCredito         : this.selecaoLinhaCredito          ? this.selecaoLinhaCredito.value               : null,
        sqTpProjeto            : this.selecaoTipoProjeto           ? this.selecaoTipoProjeto.value                : null,
        sqModalidadeSeguro     : this.selecaoModalidadeSeguro      ? this.selecaoModalidadeSeguro.value           : null,
        cdItemAgropecuario     : this.selecaoItemAgropecuario      ? parseInt(this.selecaoItemAgropecuario.value) : null,
        sqRegiao               : this.selecaoMunicipio             ? this.selecaoMunicipio.value                  : null,
        cidade                 : this.selecaoMunicipio             ? this.selecaoMunicipio.name.split(' - ')[0]   : null,
        estado                 : this.selecaoMunicipio             ? this.selecaoMunicipio.name.split(' - ')[1]   : null,
        cdSafra                : this.selecaoSafra                 ? this.selecaoSafra.name                       : null,
        qtArea                 : this.areaHa                       ? this.areaHa                                  : null,
        cdOperacaoCred         : this.nOperacao                    ? this.nOperacao                               : null,
        vlOrcado               : this.vlOrcado                     ? this.vlOrcado                                : null,
        vlAstec                : this.vlAstec                      ? this.vlAstec                                 : 0,
        dtCredito              : this.dataCredito                  ? this.dataCredito                             : null,
        cdBanco                : this.selecaoInstituicaoFinanceira ? this.selecaoInstituicaoFinanceira.value      : null,
        nrAgencia              : this.selecaoAgencia               ? this.selecaoAgencia.value                    : null,
        dtVctoFinanc           : this.dataVencBoleto               ? this.dataVencBoleto                          : "",
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira ? this.selecaoInstituicaoFinanceira.value      : null,
      };

      return dados;
    },

    async voltar() {
      const dadosAoVoltar = await this.montarObjeto();

      if((this.statusProjeto === "ELABORADO" || this.importacao) && JSON.stringify(dadosAoVoltar) !== JSON.stringify(this.dadosAoCarregar)){
        Swal.fire({
          icon             : "warning",
          title            : "ATENÇÃO",
          text             : "Caso confirme, os dados cadastrados serão perdidos. Deseja sair sem salvar?",
          showCancelButton : true,
          confirmButtonText: "Sim",
          cancelButtonText : "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.removeItem('exibirCamposImportacao');
            
            this.importacao ? this.$router.push("/astec/projetos/lotesImportacao/projetosLote") : this.$router.push("/astec/projetos");
          } 
        });
      }else{
        localStorage.removeItem('exibirCamposImportacao');
        
        this.importacao ? this.$router.push("/astec/projetos/lotesImportacao/projetosLote") : this.$router.push("/astec/projetos");
      }
    },

    formatCpfCnpj(option) {
      return option.cpfCnpj;
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";           // Retorna string vazia se nulo ou indefinido
      return value.replace(/\D/g, ""); // Remove tudo que não for número
    },
    
    updateSearch(query) {
      this.searchQuery = query; // Atualiza a pesquisa em tempo real
    },

    limparFormCadastro() {
      this.sqProjetoVar                 = "";
      this.cdProjeto                    = 30;
      this.selecaoClienteRural          = "";
      this.numeroProjeto                = "";
      this.dataProjeto                  = "";
      this.selecaoLinhaCredito          = "";
      this.selecaoTipoProjeto           = "";
      this.selecaoModalidadeSeguro      = "";
      this.selecaoItemAgropecuario      = "";
      this.selecaoMunicipio             = "";
      this.selecaoSafra                 = "";
      this.areaHa                       = "";
      this.nOperacao                    = "";
      this.vlOrcado                     = 0;
      this.vlAstec                      = 0;
      this.dataCredito                  = "";
      this.selecaoInstituicaoFinanceira = "";
      this.selecaoAgencia               = "";
      this.dataVencBoleto               = "";
      this.selecaoInstituicaoFinanceira = "";
      this.submit                       = false;
    },

    gerarBoleto(){
      this.loadingSalvar = true;

      this.$http.get(`/api/astec/projetos/gerarBoleto/${this.sqProjetoVar}`, {
        responseType: 'blob'
      })
      .then(response => {
        const blob        = new Blob([response.data], { type: 'application/pdf' });
        this.urlPagamento = URL.createObjectURL(blob);
        this.abreModal    = true;
      })
      .catch(async error => {
        if (error.response && error.response.data instanceof Blob) {
          
          const text    = await error.response.data.text();
          const message = JSON.parse(text); 

          this.$tools.alerta(message.message || "Erro ao gerar boleto do projeto", "error");

        } else {
          this.$tools.alerta("Erro ao gerar boleto do projeto", "error");
        }
      })
      .finally(() => {
        this.loadingSalvar = false;
      });
    },

    gerarPix(){
      this.loadingSalvar = true;

      this.$http.post(`/api/astec/projetos/gerarPix/${this.sqProjetoVar}`, {
        valor: this.vlAstec
      })
      .then(response => {
        if (response.status === 200) {
          this.qrCodeImage  = response.data.qrCode;
          this.textAreaData = response.data.copiaCola || '';
          this.mostraQRCode = true;
        }
      })
      .catch(error => {
        if(error.response.data.erro == true){
          this.$tools.alerta(error.response.data.mensagem, "error");
        }else{
          this.$tools.alerta("Erro ao gerar pix do projeto", "error");
        }
      })
      .finally(() => {
        this.loadingSalvar = false;
      });
    },
  },
};
</script>

<style>

  .is-valid .v-money {
    border-color: #34c38f !important;
  }
  .is-invalid .v-money {
    border-color: #f46a6a !important;
  }

</style>